import {
	ChipField,
	Datagrid,
	ImageField,
	List,
	ReferenceArrayField,
	SingleFieldList,
	TextField,
	TextInput,
} from 'react-admin';

const LectureList = () => {
	return (
		<List
			filters={[
				<TextInput source="expert_name.he" label="שם מרצה" />,
				<TextInput source="title.he" label="כותרת" />,
			]}
		>
			<Datagrid rowClick="edit">
				<TextField source="title.he" textAlign="right" label="כותרת" />
				<TextField source="expert_name.he" textAlign="right" label="שם מרצה" />
				<ReferenceArrayField textAlign="right" reference="lecture/category" source="category" label="קטגוריות">
					<SingleFieldList>
						<ChipField source="name.he" />
					</SingleFieldList>
				</ReferenceArrayField>
				<ImageField textAlign="right" source="image" label="תמונה" />
			</Datagrid>
		</List>
	);
};

export default LectureList;
